// src/components/Hero.jsx
import "./Hero.css";

export default function Hero({
  title,
  subtitle,
  mediaType,
  mediaSrc,
  children,
}) {
  const hasMedia = Boolean(mediaSrc);

  return (
    <section className=" hero-section">
      {hasMedia ? (
        mediaType === "video" ? (
          <video
            className="background-video"
            src={mediaSrc}
            autoPlay
            loop
            muted
            playsInline
          />
        ) : (
          <img className="background-video" src={mediaSrc} alt="Background" />
        )
      ) : (
        // <-- fallback solid colour
        <div className="background-fallback" />
      )}

      <div className="overlay" />

      <div className="hero-content">
        <h1 className="hero-title">{title}</h1>
        <p className="hero-subtitle">{subtitle}</p>
        <div className="hero-buttons">{children}</div>
      </div>
    </section>
  );
}
